import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

export function formatPrice(price) {
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
  }).format(price);
}

export function formatDate(dateString) {
  return new Date(dateString).toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}

export function formatDateTime(dateString) {
  return new Date(dateString).toLocaleString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function getStatusColor(status) {
  const colors = {
    nouveau: 'bg-yellow-100 text-yellow-700 border border-yellow-300',
    brouillon: 'bg-slate-100 text-slate-600',
    envoye: 'bg-blue-100 text-blue-700',
    relance_1: 'bg-orange-100 text-orange-700',
    relance_2: 'bg-orange-200 text-orange-800',
    relance_3: 'bg-red-100 text-red-700',
    en_etude_financement: 'bg-purple-100 text-purple-700 border border-purple-300',
    financement_en_cours: 'bg-purple-100 text-purple-700 border border-purple-300',
    accepte: 'bg-green-100 text-green-700',
    refuse: 'bg-red-100 text-red-700',
    sans_suite: 'bg-gray-200 text-gray-700',
    expire: 'bg-amber-100 text-amber-700',
    archive: 'bg-purple-100 text-purple-700',
  };
  return colors[status] || colors.brouillon;
}

export function getStatusLabel(status) {
  const labels = {
    nouveau: '🆕 Nouveau',
    brouillon: 'Brouillon',
    envoye: 'Envoyé',
    relance_1: 'Relancé 1',
    relance_2: 'Relancé 2',
    relance_3: 'Relancé 3',
    en_etude_financement: '📋 Financement',
    financement_en_cours: '💰 Financement',
    accepte: 'Accepté',
    refuse: 'Refusé',
    sans_suite: 'Sans suite',
    expire: 'Expiré',
    archive: 'Archivé',
  };
  return labels[status] || status;
}

export function getActivityIcon(type) {
  return {
    appel: { icon: 'Phone', color: 'bg-blue-100 text-blue-600' },
    sms: { icon: 'MessageSquare', color: 'bg-green-100 text-green-600' },
    mail: { icon: 'Mail', color: 'bg-purple-100 text-purple-600' },
    note: { icon: 'StickyNote', color: 'bg-amber-100 text-amber-600' },
    devis_envoye: { icon: 'Send', color: 'bg-blue-100 text-blue-600' },
    devis_relance: { icon: 'RefreshCw', color: 'bg-orange-100 text-orange-600' },
    devis_cloture: { icon: 'XCircle', color: 'bg-gray-100 text-gray-600' },
    devis_accepte: { icon: 'CheckCircle', color: 'bg-green-100 text-green-600' },
    devis_refuse: { icon: 'XCircle', color: 'bg-red-100 text-red-600' },
  }[type] || { icon: 'Circle', color: 'bg-slate-100 text-slate-600' };
}

export function getCategoryIcon(category) {
  const icons = {
    godet: 'Shovel',
    chenilles: 'Footprints',
    attache_rapide: 'Link',
    hydraulique: 'Droplet',
    cabine: 'Home',
    securite: 'Shield',
    autre: 'Plus',
  };
  return icons[category] || 'Package';
}

// Fix image URLs - convert relative paths to full URLs and handle invalid values
export function getImageUrl(imageUrl) {
  if (!imageUrl || imageUrl === 'None' || imageUrl === 'null' || imageUrl === 'undefined') {
    return null;
  }
  
  // If it's already a full URL, return as-is
  if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://')) {
    return imageUrl;
  }
  
  // If it's a relative API path, prefix with backend URL
  if (imageUrl.startsWith('/api/')) {
    const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
    return `${backendUrl}${imageUrl}`;
  }
  
  return imageUrl;
}
